import React from 'react';
import { Row, Col } from 'reactstrap';
import Box from '@mui/material/Box';
import {
    Block,
    FlexDiv,
    Heading2,
    Heading3,
    InlineProgressBar,
    TextWithTooltipIcon,
} from '@awarego-ui/components';
import styled from 'styled-components';
import { calculateColor, defaultZero } from '../../../../utils/helpers';
import ThemedSpinner from '../../../../components/themed/ThemedSpinner';
import LessonsDeliveredDonut from '../LessonsDeliveredDonut';
import ProgressChart from '../ProgressChart';

const HugeHeading = styled.h1`
    font-size: 56px;
    font-weight: 700;
    text-align: center;
`;

function ScormOverview({
    editingAutomation,
    chartMetrics,
    chartMetricsLoading,
    chartMetricsMigrating,
    score,
}) {
    if (chartMetricsLoading) return <ThemedSpinner />;

    return (
        <Row>
            <Col
                md="3"
                xs="12"
                style={{ display: 'flex', flexDirection: 'column' }}
            >
                <Block>
                    <Row>
                        <Col md="12" xs="12">
                            <TextWithTooltipIcon
                                textComponent={
                                    <Heading2>Lessons delivered</Heading2>
                                }
                                tooltipText="Lessons that have already been sent."
                            />
                        </Col>
                        <Col md="12" xs="12">
                            <LessonsDeliveredDonut
                                lessonsDelivered={
                                    editingAutomation.lessonsSent
                                }
                                lessonsTotal={editingAutomation.lessonsTotal}
                                chartData={chartMetrics}
                            />
                        </Col>
                    </Row>
                </Block>
                <Block gap={16}>
                    <Heading3>Enrolled employees</Heading3>
                    <HugeHeading>{editingAutomation.totalUsers}</HugeHeading>
                </Block>
            </Col>
            <Col md="9" xs="12">
                <Row>
                    <Col
                        md="6"
                        xs="12"
                        style={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <Block>
                            <TextWithTooltipIcon
                                textComponent={
                                    <Heading2>Completion rate</Heading2>
                                }
                                tooltipText="Number of employees who have fully completed the training."
                            />
                            <Box height={45} />
                            <p className="mtb20">
                                <strong>
                                    {editingAutomation.completedUsers} of{' '}
                                    {editingAutomation._rawData.totalUsers}{' '}
                                    employees completed the training
                                </strong>
                            </p>
                            <FlexDiv $noWrap>
                                <FlexDiv fullWidth alignCenter>
                                    <InlineProgressBar
                                        customColor={calculateColor(
                                            editingAutomation.completionRate
                                        )}
                                        value={editingAutomation.completionRate}
                                        fullWidth
                                    />
                                </FlexDiv>
                                <FlexDiv flexGrow={1}>
                                    <Heading2
                                        color={calculateColor(
                                            editingAutomation.completionRate
                                        )}
                                    >
                                        {editingAutomation.completedUsers}/
                                        {editingAutomation._rawData.totalUsers}
                                    </Heading2>
                                </FlexDiv>
                            </FlexDiv>
                        </Block>
                    </Col>
                    <Col
                        md="6"
                        xs="12"
                        style={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <Block>
                            <TextWithTooltipIcon
                                textComponent={
                                    <Heading2>Average progress</Heading2>
                                }
                                tooltipText="Average completion across all employees."
                            />
                            <p className="mtb20">
                                <strong>
                                    {defaultZero(score).toFixed(0)}% of
                                    training completed on average
                                </strong>
                            </p>
                            <FlexDiv $noWrap>
                                <FlexDiv fullWidth alignCenter>
                                    <InlineProgressBar
                                        customColor={calculateColor(score)}
                                        value={score}
                                        fullWidth
                                    />
                                </FlexDiv>
                                <FlexDiv flexGrow={1}>
                                    <Heading2 color={calculateColor(score)}>
                                        {defaultZero(score).toFixed(0)}/100
                                    </Heading2>
                                </FlexDiv>
                            </FlexDiv>
                        </Block>
                    </Col>
                </Row>
                <Block>
                    {chartMetricsMigrating ? (
                        <Heading2>Preparing data</Heading2>
                    ) : (
                        <ProgressChart
                            chartData={chartMetrics}
                            hideCurrentScore
                        />
                    )}
                </Block>
            </Col>
        </Row>
    );
}

export default ScormOverview;
